/* src/app/timeline-workshop/partials/timeline-workshop-toolbar/timeline-workshop-toolbar.component.scss */
.datePicker {
  display: inline-block;
  position: absolute;
  left: 42rem;
  top: 7rem;
}
.timelineToolbarContainer {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  width: 77%;
  position: fixed;
}
.dateSelectorContainer {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  gap: 0.5rem;
}
.dateSelectorContainer button {
  background: transparent;
  border: 0;
  box-shadow: none;
}
.dateSelectorContainer button.currentTimeButton {
  background-color: transparent;
  border: 1px solid #17a2b8;
  border-radius: 4px;
  padding: 0.4rem 0.8rem;
  color: #17a2b8;
  font-weight: 500;
  font-size: 0.9rem;
  margin-left: 0.5rem;
}
.dateSelectorContainer button.currentTimeButton:hover {
  background-color: #17a2b8;
  color: white;
  cursor: pointer;
}
.dateSelectorContainer button.currentTimeButton i {
  font-size: 1rem;
}
.dateSelectorContainer i {
  font-size: 2rem;
}
.dateSelectorContainer i:hover {
  color: #2196f3;
  cursor: pointer;
}
.dateSelectorContainer .dateSelectorBox {
  background-color: transparent;
  padding: 0.3rem;
  width: 20rem;
  font-size: 1.2rem;
  text-align: center;
  margin-top: 0.7rem;
  color: #34495e;
  font-weight: bold;
}
.dateSelectorContainer .dateSelectorBox:hover {
  color: #2196f3;
  cursor: pointer;
}
.vehicleTypeSelector {
  width: 11rem;
}
/*# sourceMappingURL=timeline-workshop-toolbar.component.css.map */
